<script>
	import ButtonViewsXpages from './componentes/ButtonViewsXpages.svelte';
	import Helper from './components/Helper.svelte';
  import { viewsXpages, registerXpage } from './stores/store.js'; // CAMBIO AGREGAR quitar duplicado  
  import BotonOrder from './componentes/BotonOrder.svelte'; // CAMBIO AGREGAR 
  import { fade, fly } from 'svelte/transition';
  import Input from './componentes/Forms/Input.svelte';
  import Modal from './components/Modal.svelte';

  import { push } from 'svelte-spa-router';
  import AnimationContainer from './components/AnimationContainer.svelte';
  import Navbar from './components/Navbar.svelte';
  import Titlesection from "./components/Titlesection.svelte";
  import { autentificado, prefix, urlapi,login,miPermiso,iduser } from './stores/store';

  import DatagridRow from './componentes/DatagridRow.svelte';
	import DatagridTitle from './componentes/DatagridTitle.svelte';
	import DatagridCell from './componentes/DatagridCell.svelte';
	import Datagrid from './componentes/Datagrid.svelte';

  import Infopagination from './components/Infopagination.svelte';
	import Pagination from './components/Pagination.svelte';
	import Searchsection from "./components/Searchsection.svelte";
	import { object2array, postData, verifyAccess } from './scripts';

  //verifyAccess($login,$miPermiso,'usuarios','access')

  /* PERMISOS */
  let viewPage=false;

  if($login===false)
  {
      push('/login')
  } else if( $miPermiso.usuarios.access===false ) {
      push('/sinpermiso')
  } else {
      viewPage=true;
  }
  /* FIN PERMISOS */


  let avanzado=false;
  let uid=null; // CAMBIO AGREGAR VARIABLE
  const res=null;
  let datagrid=[]
  let cargando=false;
  let pageActual=0;
  let dataPagination={};
  let searchText='';
  let orderField='iduser';
  let orderDir='ASC';
  let roles= {'0': 'Personalizado' }
  let roles_combo= [{'ALL':'Todos'},{'0': 'Personalizado' }]
  let rol='ALL';
  let cargado_roles=false;
  
  function eventPage(event)
  {
      pageActual=event.detail.text;
      loadData()
  }

  function eventSearch(event)
  {
      pageActual=0;
      searchText=event.detail.text
      loadData()
  }

  function eventText()
  {
      pageActual=0;
      loadData()
  }

  async function loadData()
  {
      cargando=true;

      let datos={ 
          'cmd': "users_list",
          pagination: $viewsXpages,
          page: pageActual,
          order: orderField,
          dir: orderDir,
          iduser: $iduser,
          viewSelf: $miPermiso.usuarios.viewSelf,
          rol: rol
      }
      let datos2={ 
          'cmd': "users_listPermisosID",
          'permisos': false
      }


      if(avanzado===true)
      {
          if(searchText!='') datos={...datos, 'search':searchText }
      }      

      if(cargado_roles===false)
      {
          const res = await postData($urlapi, [datos, datos2])
          .then(data => {
              object2array(data[1].result).forEach(function(dato) {
                roles={...roles,[dato.id]:dato.nombre}
                roles_combo= [...roles_combo,{[dato.id]:dato.nombre}]
              });              
              datagrid= object2array(data[0].result);
              dataPagination=data[0].pagination;
              cargando=false;
          });
          cargado_roles=true;
      } else {
          const res = await postData($urlapi, [datos])
          .then(data => {
              datagrid= object2array(data[0].result);
              dataPagination=data[0].pagination;
              cargando=false;
          });
      }
      
  }

  let edit= function(id) { push('/usuario/'+id); }
  let nuevo=function () { push('/usuario/0')}
  let eliminar=function() { 
        postData($urlapi, [{ 
            'cmd':'users_delete',
            'id':seleccionado,
        }]).then(data => {
            pageActual=0;
            loadData()
        });
  }

	function orderTable(event) {
    if(cargando===false) {
      pageActual=0;
      orderField=event.detail.order;
      orderDir=event.detail.dir;
      loadData()
    }    
	}


  let helper=false;

  let seleccionado=false;
  let selected= function (event) { 
      if(seleccionado==false || seleccionado!==event.detail.id) {
        seleccionado=event.detail.id
      } else {
        seleccionado=false
      }
  }

</script>

{#if viewPage===true}

<Navbar />

<AnimationContainer>

      <Titlesection>
        <span slot="title"><i class="bi bi-people me-1" />Usuarios</span>
        <span slot="toolbar">

          {#if $miPermiso.usuarios.insert===true}
            <button class='btn btn-primary' on:click={nuevo} on:mouseenter={()=>helper='Crear Registro'} on:mouseleave={()=>helper=false}><i class="bi bi-plus-circle"></i></button>
          {/if}

          {#if $miPermiso.usuarios.edit===true}
            <span on:mouseenter={()=>helper='Editar Registro'} on:mouseleave={()=>helper=false}><button disabled={!seleccionado} class='btn btn-success' on:click={()=>edit(seleccionado)}><i class="bi bi-pencil-square"></i></button></span>
          {/if}
          
          {#if $miPermiso.usuarios.delete===true}
            <Modal classButton='btn-danger' iconButton='bi-trash' functionSi={eliminar} title='ADVERTENCIA' disabled={!seleccionado}  on:mouseenter={()=>helper='Eliminar Registro'} on:mouseleave={()=>helper=false}>
              Esta seguro que desea <strong>Eliminar</strong> el registro?<br/>Se perderán todos los datos.
            </Modal>
          {/if}

          {#if avanzado===false}
            <button class='btn btn-secondary' on:click={(e)=>{avanzado=!avanzado; eventSearch(e);}} on:mouseenter={()=>helper='buscador avanzado'} on:mouseleave={()=>helper=false}><i class="bi bi-funnel"></i></button>
          {:else}
            <button class='btn btn-success' on:click={(e)=>{avanzado=!avanzado; eventSearch(e);}} on:mouseenter={()=>helper='buscador avanzado'} on:mouseleave={()=>helper=false}><i class="bi bi-funnel"></i></button>
          {/if}

          <ButtonViewsXpages on:load={()=>{pageActual=0; loadData();}} on:mouseenter={()=>helper='Registros por página'} on:mouseleave={()=>helper=false}/>
         
          <BotonOrder uid={uid} on:mouseenter={()=>helper='Ordenar'} on:mouseleave={()=>helper=false} />
        </span>
      </Titlesection>

      {#if avanzado===true}
      <div class="container-fluid mt-1" in:fly={{y:-10,duration:500}}>
          <div class="row">
  
              <div class='col-12 col-md-8 col-lg-8 mb-2 mt-2'>
                  <Input label='Filtrar por ID, NOMBRE, APELLIDOS, NIT, EMAIL' bind:value={searchText} on:change={eventText} />
              </div>
              <div class='col-12 col-md-4 col-lg-4 mb-2 mt-2'>
                <Input label='Roles' bind:value={rol} tipo='select' on:change={eventText} datos={roles_combo} />
              </div>                 
          </div>
      </div>
      {/if}



      <!-- DATA GRID -->
      <div class="container-fluid mt-2">
        <div class="row">
          <div class="col-12">

              <Datagrid bind:uid={uid} order={orderField} dir={orderDir} on:order={orderTable}>

                  <svelte:fragment slot="header">
                        <DatagridTitle width='100px' order="iduser" title='ID'/>
                        <DatagridTitle order="nombre" title='Nombre'/>
                        <DatagridTitle order="apellidos" title='Apellidos'/>
                        <DatagridTitle title='Email'/>
                        <DatagridTitle title='Rol'/>
                  </svelte:fragment>
                  <svelte:fragment slot="body">
                    {#each datagrid as item}
                    <DatagridRow id={item.iduser} bind:seleccionado={seleccionado} on:select={selected}>
                          <DatagridCell title='ID'>{item.iduser}</DatagridCell>
                          <DatagridCell title='Nombre' primary>{item.nombre}</DatagridCell>
                          <DatagridCell title='Apellidos' primary>{item.apellidos}</DatagridCell>
                          <DatagridCell title='Email' primary>{item.email}</DatagridCell>
                          <DatagridCell title='Rol' primary>{roles[item.rol]}</DatagridCell>
                    </DatagridRow>
                    {/each}
                  
                  </svelte:fragment>
              </Datagrid>

          </div>
        </div>
      </div>

      <!-- PAGINACIÓN -->
      <div class="container mt-3">
        <div class="row">
          <div class="col-12 col-md-6 text-end text-md-start">
            <Infopagination data={dataPagination}/>
          </div>
          <div class="col-12 col-md-6">
            <Pagination selected={pageActual} data={dataPagination} on:page={eventPage}/>
          </div>
        </div>
      </div>

      <Helper bind:text={helper}></Helper>

</AnimationContainer>

{/if}